import { render, staticRenderFns } from "./PatientLetter.vue?vue&type=template&id=201f9110&"
import script from "./PatientLetter.vue?vue&type=script&lang=ts&"
export * from "./PatientLetter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports